import { type FC } from "react";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import { Grid, IconButton, Paper, Typography } from "@mui/material";
import { FormattedMessage } from "react-intl";

import { type OAuthResponse } from "../../../types";
interface OAuthSuccessStepProps {
	readonly credentials: OAuthResponse;
	readonly onCopyToClipboard: (value: string) => void;
}

export const OAuthSuccessStep: FC<OAuthSuccessStepProps> = ({ credentials, onCopyToClipboard }) => {
	return (
		<Grid container direction="column" spacing={2}>
			<Grid container direction="column" gap={1}>
				<Typography>
					<FormattedMessage
						id="Here are your new OAuth credentials"
						defaultMessage="Here are your new OAuth credentials"
					/>
				</Typography>
				<Typography fontWeight={700}>
					<FormattedMessage
						id="This is the only time this will be displayed, so be sure to copy it."
						defaultMessage="This is the only time this will be displayed, so be sure to copy it."
					/>
				</Typography>
			</Grid>

			<Grid container direction="column" gap={0.5}>
				<Typography fontWeight={500}>
					<FormattedMessage id="Client ID" defaultMessage="Client ID" />
				</Typography>
				<Paper
					component={Grid}
					container
					variant="outlined"
					justifyContent="space-between"
					alignItems="center"
					sx={{ p: 2 }}
				>
					<Typography>{credentials.responseData?.clientId}</Typography>
					<IconButton
						size="small"
						onClick={() => onCopyToClipboard(credentials.responseData?.clientId ?? "")}
						data-pendoid="connection-success__button__copy-client-id"
					>
						<ContentCopyOutlinedIcon sx={{ fontSize: 20 }} />
					</IconButton>
				</Paper>
			</Grid>

			<Grid container direction="column" gap={0.5}>
				<Typography fontWeight={500}>
					<FormattedMessage id="Client Secret" defaultMessage="Client Secret" />
				</Typography>
				<Paper
					component={Grid}
					container
					variant="outlined"
					justifyContent="space-between"
					alignItems="center"
					sx={{ p: 2 }}
				>
					<Typography>{credentials.responseData?.clientSecret}</Typography>
					<IconButton
						size="small"
						onClick={() => onCopyToClipboard(credentials.responseData?.clientSecret || "")}
						data-pendoid="connection-success__button__copy-client-secret"
					>
						<ContentCopyOutlinedIcon sx={{ fontSize: 20 }} />
					</IconButton>
				</Paper>
			</Grid>
		</Grid>
	);
};
